const Style = {
    page: 'mx-auto flex min-h-[50vh] w-full max-w-2xl flex-col items-center px-6 py-16',
    loading: 'flex justify-center py-12',
    card: 'flex w-full flex-col items-center rounded-2xl border border-border bg-surface p-8 text-center shadow-sm',
    logoImg: 'h-24 w-24 rounded-xl border border-border object-cover',
    title: 'mt-5 text-2xl font-semibold text-text-primary',
    description:
        'mt-4 max-w-lg text-sm leading-relaxed text-text-secondary',
};

export default Style;
